import axios from 'axios'

// 获取系统参数配置列表
export function querySysParam (datas) {
  const url = `/sysParam/querySysParam`
  return new Promise((resolve, reject) => {
    axios.get(url, {params: datas}).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 编辑系统参数
export function updateSysParam (datas) {
  const url = `/sysParam/updateSysParam`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 获取数据字典列表
export function querySysDictionaryTypeList (datas) {
  const url = `/sysDictionaryType/querySysDictionaryTypeList`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 获取数据字典子项列表
export function querySysDictionaryList (datas) {
  const url = `/sysDictionary/querySysDictionaryList`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 新增数据字典子项
export function addSysDictionary (datas) {
  const url = `/sysDictionary/addSysDictionary`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 编辑数据字典子项
export function updateSysDictionary (datas) {
  const url = `/sysDictionary/updateSysDictionary`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 删除数据字典子项
export function delSysDictionary (datas) {
  const url = `/sysDictionary/delSysDictionary`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 平台用户类型语言配置管理
export function queryUserTypeLanguageList (datas) {
  const url = `/userTypeLanguage/queryUserTypeLanguageList`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 编辑平台用户类型语言配置
export function updateUserTypeLanguage (datas) {
  const url = `/userTypeLanguage/updateUserTypeLanguage`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/system/index.js